import getFirstSubdomain from '../../../shared-functions/DomainsplitFunction';
import getToken from '../../helpers';

/**
 * Get default headers details function
 * @returns
 */
const defaultHeaders = () => {
  const accessToken = getToken();
  const headers: HeadersInit = {};
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  const domain = getFirstSubdomain() || '';
  const blocked = ['admin-dev', 'admin-test', 'admin', 'localhost', 'cpo', 'cpo-test', 'cpo-dev'];

  if (domain && !blocked.some(d => domain.includes(d))) {
    headers.domain = domain;
  }
  return Object.keys(headers).length > 0 ? headers : null;
};

export default defaultHeaders;
